import React, { useState } from "react";
import { Scatter } from "react-chartjs-2";
import { Card, CardBody, UncontrolledTooltip } from "reactstrap";

import CardHeader from "../Layout/CardHeader";
import SuperInsightsModal from "../Ia/SuperInsightsModal";
import Meta from '../Layout/Meta';


import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";

// Registrar módulos necessários
ChartJS.register(CategoryScale, LinearScale, PointElement, Tooltip, Legend);

const ScatterChart = ({ item }) => {

  // Verificação segura do item e seus valores
  const safeItem = item || {};

  // Destructuring com fallbacks seguros
  const {
    Sigla = '',    
    Descricao_Dashboard_Componente: titulo = "-",
    dadosComponente,
    Valor_Meta = {},
    Texto_Info = "-",
    Texto_BizAI = "",
    ESG_Info = "-",
    Codigo_Transacao_Link = "",
    Titulo_Transacao_Link = "",
    opcoesComponente,
  } = safeItem;

  // Controle do Modal
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const togglePopup = () => setIsPopupOpen(!isPopupOpen);
 const slugId = Sigla.trim().replace(/\s+/g, "-");
    
  return (
       <>
    <Card className="w-100 h-100 ">
      <CardBody className="w-100 h-100 d-flex flex-column cardbody-dash">
        <CardHeader
            titulo={titulo}
            Texto_Info={Texto_Info}
            ESG_Info={ESG_Info}
            togglePopup={togglePopup}
            slugId={slugId}
            textoIA={Texto_BizAI}
            Codigo_Transacao_Link={Codigo_Transacao_Link}
            Titulo_Transacao_Link={Titulo_Transacao_Link}
        />

          {/* Metas e Valores */}       
          <Meta Valor_Meta={Valor_Meta} />

        {/* Gráfico */}
        <div style={{ marginTop: "20px", height: "100%" }}>
          <Scatter data={dadosComponente} options={opcoesComponente} />
        </div>
      </CardBody>
    </Card>

      {/* Modal de Insights */}
      <SuperInsightsModal
        isOpen={isPopupOpen}
        toggle={togglePopup}
        textoIA={Texto_BizAI} // Passamos somente o texto da pergunta
      />
    </>
  );
};

export default ScatterChart;
